import React from "react";
import Icon from "assets/icons";
import classNames from "classnames";
import Button from "shared/components/button";
import { useAuth } from "shared/context/auth";
import { UserDropdownConfig } from "./types";
import Headshot from "apps/myExperience/components/headshot";
import { getNameInitials } from "shared/utils";
import GlobalMenuPopover from "../menuPopover";
import { positionRight } from "@reach/popover";
import useUserDropdownService from "./service";
import Variant from "shared/enums/Variant";

export default function UserDropdown(props: UserDropdownConfig) {
  const auth = useAuth();
  const service = useUserDropdownService();

  return (
    <GlobalMenuPopover
      menuTitle={""}
      key={service.randomKey}
      position={positionRight}
      icon={
        <span className="userDropdown_pic">
          <Icon.Person />
        </span>
      }
      className="userDropdown">
      <div className="userDropdownContainer">
        <div className="userDropdown_details">
          {props.showProfilePicture && (
            <Headshot
              imageLocation={props.profilePictureLocation}
              nameInitials={getNameInitials(`${auth.userDetail?.firstName} ${auth.userDetail?.lastName}`)}
            />
          )}
          <span
            className="userDropdown_details--name"
            title={`${auth.userDetail?.firstName} ${auth.userDetail?.lastName}`}>
            {`${auth.userDetail?.firstName} ${auth.userDetail?.lastName}`}
          </span>
          <small title={auth.userDetail?.email} className="userDropdown_details--email">
            {auth.userDetail?.email}
          </small>
        </div>

        {props.dropdownItemList?.map((item, index) => (
          <Button.Custom
            key={index}
            variant={Variant.LINK}
            className={classNames("dropdown_item smooth", {
              isNegativeAction: item.isNegativeAction
            })}
            onClick={e => {
              item.clickHandler?.(e);
              if (!item.doNotCloseOnClick) {
                service.incrementKey();
              }
            }}>
            <span className="dropdown_item--icon">{item.icon}</span>
            <small className="dropdown_item--label">
              {item.customLabel ? item.customLabel(service.incrementKey) : item.label}
              {item.additionalInfo && <small className="dropdown_item--additionalInfo">{item.additionalInfo}</small>}
            </small>
          </Button.Custom>
        ))}
      </div>
    </GlobalMenuPopover>
  );
}
